export default {
  common: {
    searchField: '检索字段',
    relationQuery: '关联词查询',
    pageName: '版名',
    edition: '版次',
    issueNumber: '期号',
    sourceField: '文章来源',
    column: '栏目',
    paperName: '报刊名称',
    layoutType: '版面类型',
    normalLayout: '正常',
    jointLayout: '连版/通版',
    traditionalSwitch: '繁体检索',
    simplified: '简体',
    traditional: '繁体',
    sameWord: '同义词扩展',
    oppositeWord: '反义词扩展',
    type: '类型',
    dateSort: '日期排序',
    contentFilter: '内容筛选',
    ascending: '升序',
    descending: '降序',
    relatedness: '相关度排序',
    title: '标题',
    author: '作者',
    content: '内容',
    body: '正文',
    titleContent: '标题+内容',
    aiSummary: 'AI摘要',
    default: '默认',
    articleClassification: '文章分类',
    articleGenre: '文章体裁',
    region: '地区',
    person: '人物',
    headline: '头条',
    editorName: '编辑姓名',
    publicStatus: '对外状态',
    genreMessage: '消息',
    genreCommunication: '通讯',
    genreEditorial: '社论',
    genreCommentary: '评论',
    genreSpeech: '讲话',
    genreTheoreticalArticle: '理论文章',
    genreLetter: '来信',
    genreCommunique: '公报',
    genreAnnouncement: '公告',
    genreSupplement: '副刊文章',
    genreInterview: '专访访谈',
    genreImagePromotion: '形象宣传',
    other: '其他',
    vectorKeyword: '关键词',
    vectorKeywordPlaceholder: '请输入检索关键词，或导入图片',
    vectorKeywordRequired: '请输入检索关键词',
    vectorKeywordOrImageRequired: '请输入关键词或导入图片',
    similarCount: '相似数量',
    importImage: '导入图片',
    imageImportedPreview: '已导入图片，点击可放大查看',
    clearImage: '清除图片',
    imageOnly: '只能上传图片文件',
    selectCategoryTitle: '选择分类',
    selectAiCategoryTitle: '选择AI分类',
    filterCategoryPlaceholder: '输入关键字进行过滤'
  }
}
